import React from 'react';
import '../CSS/navbar.css';
export default function Navbar() {
  return (
    <div className='nav-head'>
            <img src='/mainPage.png'/>
          NSQLDB
    </div>
  )
}
